import React from 'react';

import { Stack, Box, SearchBar } from '@metarouter-private/mr-mui';

import { useTrackPage } from '@ion/api';

import CenteredLoader from 'app/components/CenteredLoader';

import Card from './Card';
import PrimaryExplanationMessage from './PrimaryExplanationMessage';
import useClustersTabConfig from './useClustersTabConfig';

function ClustersTab() {
  useTrackPage('clusters_tab_viewed');

  const { loadingClusters, displayedClusters, handleClusterSearch } = useClustersTabConfig();

  if (loadingClusters) {
    return <CenteredLoader />;
  }

  return (
    <Stack spacing={2}>
      <PrimaryExplanationMessage />

      <Box width="40%">
        <SearchBar
          name="search"
          aria-label="Search clusters"
          placeholder="Search clusters"
          size="small"
          onChange={handleClusterSearch}
        />
      </Box>

      <Stack direction="row" useFlexGap spacing={2} flexWrap="wrap" alignItems="stretch">
        {displayedClusters.map(cluster => (
          <Card key={cluster.id} cluster={cluster} />
        ))}
      </Stack>
    </Stack>
  );
}

export default ClustersTab;
